let _ = (t)=>t, t;
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@emotion/react';
import { tokens } from '@klarna/ui';
import RichTextMarkdown from 'features/richText/components/richTextMarkdown/RichTextMarkdown';
import { memo } from 'react';
/**
 * Disclaimer component for legal text with markdown support.
 * Uses KLUI tokens for styling.
 */ const Disclaimer = ({ children })=>{
    return /*#__PURE__*/ _jsx(RichTextMarkdown, {
        sx: css(t || (t = _`
        max-width: 100%;

        p,
        p > *,
        a {
          font-size: ${0}px;
          line-height: ${0}px;
          color: ${0};
        }

        a:hover {
          color: ${0};
        }
      `), tokens.textSizes['text/desktop/xs'], tokens.lineHeights['body/desktop/xs'], tokens.colors.light['text/subtle'], tokens.colors.light['text/subtle']),
        children: children
    });
};
export default /*#__PURE__*/ memo(Disclaimer);
